<template>
  <label class="ui-checkbox">
    <span class="ui-checkbox-input">
      <input
        v-model="computedValue"
        type="checkbox"
        :disabled="disabled"
      >
      <f-sprite-icon
        class="icon-check"
        :icon-link="$options.icons.IconCheck.id"
      />
    </span>

    <span class="ui-checkbox-label">
      <span
        v-if="headline"
        v-text="headline"
        class="ui-checkbox-headline"
      />
      {{ label }}
    </span>
  </label>
</template>

<script>
import IconCheck from '../../../assets/icons/check.svg';

export default {
  name: 'ui-checkbox',

  icons: {
    IconCheck
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      default: ''
    },

    headline: {
      type: String,
      default: ''
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    }
  }
};
</script>

<style lang="scss">
.ui-checkbox {
  display: inline-flex;
  user-select: none;

  input {
    appearance: none;
    margin: 0;
    padding: 0;
    width: 24px;
    height: 24px;
    border: 2px solid $gray_lu;
    border-radius: 4px;
    background-color: #fff;
    transition: .2s ease background-color, .2s ease border-color;
    &:checked {
      background-color: $blue;
      border-color: $blue;
      ~ .icon-check {
        transform: scale(1);
      }
    }
    &:disabled {
      background-color: $gray_lu;
      border-color: $gray_lu;
      &:not(:checked) {
        background-color: $gray_bgr;
        border-width: 1px;
      }
    }
  }

  &:hover {
    input:not(:disabled) {
      border-color: $gray_l;
      &:checked {
        background-color: $blue_hover;
        border-color: $blue_hover;
      }
    }
  }

  svg.icon-check {
    position: absolute;
    top: 0;
    margin: 4px;
    width: 16px;
    height: 16px;
    color: $white;
    transform: scale(0);
    transition: .2s ease-out transform;
  }

  &-input {
    position: relative;
    flex: 0 0 24px;
    height: 24px;
  }

  &-label {
    display: flex;
    flex-direction: column;
    margin-left: 13px;
    font-size: 14px;
    line-height: 20px;
    padding: 2px 0;
  }

  &-headline {
    font-size: 16px;
    font-weight: 600;
  }
}

@include breakpoint("desktop") {
  .ui-checkbox {
    &-icon {
      margin-right: 8px;
    }
    &-label {
      margin-left: 15px;
    }
  }
}
</style>
